import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';
import dayjs from 'dayjs';
import type { GetGSOfferedData, GSOfferedList } from './types';
import { MONITOR_LIST_TEXT } from '../../../lang';
import type { Paginator } from '../../../../Nomination/graphql/NominationForm';
import {
  modeOfStudyOptions,
  programmeTypeOptions,
} from '../../../../Application/components';
import { getOptionsLabel } from '../../../../Monitor/components';

const GS_GET_OFFERED_LIST = gql`
  query (
    $filter: OfferedApplicationFilter!
    $sort: OfferDetailSorter
    $paginator: PaginatorOptions
  ) {
    offerList(filter: $filter, sort: $sort, paginator: $paginator) {
      data {
        applicationId
        applicationNo
        applicantName
        programme
        researchArea
        studyMode
        programmeType
        entryYear
        department
        supervisor
        proposedChiefSupervisor
        status
        offerDate
      }
      paginator {
        count
        total_pages
      }
    }
  }
`;

const PROGRAMME_LEVEL = MONITOR_LIST_TEXT.PROGRAMME_LEVEL;

export const useGetOfferedList = (
  filter: any,
  sort: any,
  paginator: Paginator,
): GetGSOfferedData => {
  const { data, loading, error, refetch } = useQuery(GS_GET_OFFERED_LIST, {
    variables: { filter, sort, paginator },
    fetchPolicy: 'network-only',
  });

  let offeredListData: GSOfferedList = {
    offeredList: [],
    totalPage: 1,
    count: 0,
  };

  if (!loading && !error) {
    const offerList = data?.offerList?.data ?? [];
    const offeredList = offerList.map((element: any) => {
      const {
        applicationId,
        applicationNo,
        applicantName,
        programme,
        researchArea,
        studyMode,
        programmeType,
        department,
        proposedChiefSupervisor, // netId
        supervisor, // display name
        status,
        offerDate,
        entryYear,
      } = element;

      const studyModeLabel = modeOfStudyOptions
        .find(option => option.value === studyMode)
        ?.label?.toString();

      return {
        applicationId,
        applicationNo,
        applicantName,
        progLevel: PROGRAMME_LEVEL[programme as keyof typeof PROGRAMME_LEVEL],
        researchField: researchArea,
        studyMode: studyModeLabel,
        entryYear,
        department,
        proposedChiefSupervisor:
          supervisor +
          `${(proposedChiefSupervisor as boolean) ? '(' + proposedChiefSupervisor + ')' : ''}`,
        progType: getOptionsLabel(programmeTypeOptions, programmeType) ?? 'N/A',
        status,
        offerDate: dayjs(offerDate).format('DD/MM/YYYY,HH:mm'),
      };
    });

    const totalPage = data?.offerList?.paginator?.total_pages ?? 1;
    const count = data?.offerList?.paginator?.count ?? 0;

    offeredListData = {
      offeredList,
      totalPage,
      count,
    };
  }

  return { offeredListData, loading, error, refetch };
};
